"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _endpoints = require("./endpoints");
/**
 * @typedef CEPData
 * @type {{
 *     bairro: string;
 *     cidade: string;
 *     logradouro: string;
 *     numero: string;
 *     estado_info: {
 *         area_km2: string;
 *         codigo_ibge: string;
 *         nome: string;
 *     };
 *     cep: string;
 *     cidade_info: {
 *         area_km2: string;
 *         codigo_ibge: string;
 *     };
 *     estado: string;
 * }}
 */

var cepApi = {
  /**
   * @param {string} cep
   * @returns {Promise<CEPData>}
   **/
  consult: function () {
    var _consult = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(cep) {
      var _yield$cepEndpoint$ge, data;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            cep = cep.replace(/\D/g, "");
            _context.next = 3;
            return _endpoints.cep.get(cep);
          case 3:
            _yield$cepEndpoint$ge = _context.sent;
            data = _yield$cepEndpoint$ge.data;
            return _context.abrupt("return", data);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function consult(_x) {
      return _consult.apply(this, arguments);
    }
    return consult;
  }()
};
var _default = cepApi;
exports["default"] = _default;